import { Children, isValidElement } from "react";

import { SidebarSubItem } from "./components/sidebar-sub-item";
import { Protected } from "features/auth/components/protected";
import { isComponentTypeOf } from "util/react";

// Helper function to normalize paths by removing trailing slashes
function normalizePath(path) {
  return path.endsWith("/") ? path.slice(0, -1) : path;
}

export function isPathActive(href, pathname) {
  const normalizedHref = normalizePath(href);
  const normalizedPathname = normalizePath(pathname);
  return (
    normalizedPathname === normalizedHref ||
    normalizedPathname.startsWith(`${normalizedHref}/`)
  );
}

export function isNavItemActive(item, pathname) {
  if (item.isLink) return isPathActive(item.href, pathname);
  const subItems = findSidebarSubItems(item.children);
  return subItems.some((child) => isPathActive(child.props.href, pathname));
}

function findSidebarSubItems(children) {
  return Children.toArray(children).flatMap((child) => {
    if (!isValidElement(child)) return [];
    if (isComponentTypeOf(child, SidebarSubItem)) return [child];
    if (isComponentTypeOf(child, Protected)) {
      return findSidebarSubItems(child.props.children);
    }

    return [];
  });
}
